module.exports = __webpack_public_path__ + "static/Ontario-c1399da8c40b69f9a1ed18f496a7f0b4.png";